import queryString from 'query-string'

export const getListingPath = ({ path, domain }: { path: string; domain?: string }): string => {
  const prefix = domain ? `https://${domain}` : ''
  return `${prefix}${path}`
}

export const makeAbsoluteUrl = (url: TODO) => {
  if (typeof url !== 'string') {
    return null
  }

  return url.startsWith('/') ? url : `/${url}`
}

export const addQueryParamToUrl = ({
  url,
  key,
  value,
}: {
  url: string
  key: string
  value: string
}): string => {
  const { url: rootUrl, query } = queryString.parseUrl(url)
  const newQueryParams = {
    ...query,
    [key]: value,
  }
  return queryString.stringifyUrl({ url: rootUrl, query: newQueryParams })
}

export const removeQueryParamFromUrl = ({ url, key }: { url: string; key: string }): string => {
  const { url: rootUrl, query } = queryString.parseUrl(url)
  const newQueryParams = Object.keys(query).reduce(
    (acc, curKey) => (key === curKey ? acc : { ...acc, [curKey]: query[curKey] }),
    {}
  )
  return queryString.stringifyUrl({ url: rootUrl, query: newQueryParams })
}

export const addExistingQueryParamsToUrl = (newUrl: string, existingUrl: string) => {
  const { url: rootUrl, query } = queryString.parseUrl(newUrl)
  const { query: existingQuery } = queryString.parseUrl(existingUrl)
  const mergedQuery = { ...query, ...existingQuery }
  return queryString.stringifyUrl({ url: rootUrl, query: mergedQuery })
}
